module.exports = __webpack_public_path__ + "img/authentication.8429ecc8.svg";